module.exports = __webpack_public_path__ + "static/media/raven.581ee1b6.svg";